


export const dialogKeys = {
    MENU: "menu",
    ASSIGNITEM: "assignItems",
    PREFERENCE: "preferences",
    EXTRAGROUP: "extrasGroup",
    ITEM: "items",
    CUSTOMER: "customer",
    ORDER: "order",
    PARTIALREFUND:"PARTIALREFUND",
    SPECIFICITEMSREFUND:"SPECIFICITEMSREFUND",
    PARTIALREFUNDREASONS:"PARTIALREFUNDREASONS",
    PRINTER: "PRINTER",
    SETLOCATION: "SETLOCATION",
    SELECTONMAP: "SELECTONMAP"
}